import React from 'react';

const CashfreeLogo = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.07742 0C4.64849 0 3.49023 1.16129 3.49023 2.59397H13.0924C14.5213 2.59397 15.6796 1.43268 15.6796 0H6.07742Z"
      fill="#04AB61"
    />
    <path
      d="M3.49023 2.59397C3.49023 1.16129 4.64849 0 6.07742 0V9.62759C6.07742 11.06 4.91917 12.2216 3.49023 12.2216V2.59397Z"
      fill="#04AB61"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.89941 3.4585V6.05247H9.91728C11.3462 6.05247 12.5045 4.89117 12.5045 3.4585H6.89941Z"
      fill="#FBB016"
    />
    <path
      d="M0 6.05247C0 4.62003 1.15826 3.4585 2.58719 3.4585V13.0861C2.58719 14.5188 1.42893 15.6801 0 15.6801V6.05247Z"
      fill="#FBB016"
    />
  </svg>
);

export default CashfreeLogo;
